<template lang="pug">
  .toast-container
    //- Updating: 顯示 spinner（與 Update.vue 相同）
    template(v-if="state === 'updating'")
      .toast-body.flex.items-center.gap-x-2
        svg.animate-spin.h-5.w-5.flex-shrink-0(xmlns="http://www.w3.org/2000/svg", fill="none", viewBox="0 0 24 24")
          circle.opacity-25(cx="12", cy="12", r="10", stroke="currentColor", stroke-width="4")
          path.opacity-75(fill="currentColor", d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z")
        span {{ updatingMessage }}

    //- Complete: 顯示勾勾 + reload 按鈕（與 Update.vue 相同）
    template(v-else-if="state === 'complete'")
      .toast-body.flex.items-center.gap-x-2
        svg.h-5.w-5.text-green-400.flex-shrink-0(xmlns="http://www.w3.org/2000/svg", fill="none", viewBox="0 0 24 24", stroke="currentColor")
          path(stroke-linecap="round", stroke-linejoin="round", stroke-width="2", d="M5 13l4 4L19 7")
        span {{ completeMessage }}
        button.underline.font-bold.ms-2(@click="reload") {{ reloadText }}

    //- Idle: 顯示更新訊息 + 按鈕
    template(v-else)
      .toast-body.flex.items-center.justify-between.gap-x-3
        span {{ message }}
        button.underline.font-bold.whitespace-nowrap(@click="startUpdate") {{ buttonText }}
</template>

<script>
export default {
  name: 'ToastSwUpdate',
  props: {
    message: {
      type: String,
      default: 'New version available',
    },
    updatingMessage: {
      type: String,
      default: 'Updating...',
    },
    completeMessage: {
      type: String,
      default: 'Update complete!',
    },
    buttonText: {
      type: String,
      default: 'Update',
    },
    reloadText: {
      type: String,
      default: 'Reload',
    },
    closeToast: {
      type: Function,
      default: () => {},
    },
    onUpdate: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      state: 'idle', // 'idle' | 'updating' | 'complete'
    }
  },
  methods: {
    async startUpdate() {
      this.state = 'updating'

      try {
        if (this.onUpdate) {
          this.onUpdate()
          return
        }

        const workbox = await window.$workbox
        if (workbox) {
          // 監聽 controllerchange 事件
          const controllerChangePromise = new Promise((resolve) => {
            const handler = () => {
              navigator.serviceWorker?.removeEventListener('controllerchange', handler)
              resolve()
            }
            navigator.serviceWorker?.addEventListener('controllerchange', handler)
          })

          // 發送 skipWaiting 消息
          workbox.messageSW({ type: 'skipWaiting' })

          // 等待 controllerchange 或 timeout
          await Promise.race([
            controllerChangePromise,
            new Promise((resolve) => setTimeout(resolve, 5000)),
          ])
        }

        this.state = 'complete'
      } catch (error) {
        console.error('[SW Update] Error:', error)
        this.state = 'complete'
      }
    },
    reload() {
      this.closeToast()
      window.location.reload()
    },
  },
}
</script>

<style scoped>
@reference "@/assets/css/tailwind.css";

/* 參考 ToastBar.vue 的樣式 */
.toast-container {
  display: flex;
  align-items: center;
  height: 100%;
  width: calc(100% - 1rem);
}

.toast-body {
  @apply font-sans font-bold;
  color: white;
  font-size: 14px;
  line-height: 16px;
  width: 100%;

  @media screen and (orientation: landscape) and (min-width: 1024px) {
    font-size: 16px;
    line-height: 24px;
  }
}
</style>
